import MapDraw from '../mapDraw';

export const changeFloor = async (floorId: string) => {
  await MapDraw.map.context.changeFloor(floorId);
};
